import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Home from "../pages/home";
import { useEffect } from "react";
import PageNotFound from "../components/pageNotFound";
import TermsAndConditions from "../pages/TermsAndConditions";
import PrivacyPolicy from "../pages/privacyPolicy";
import ContactUs from "../pages/contactUs";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (hash && pathname === "/") {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else if (hash && pathname !== "/") {
      navigate(`/${hash}`);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navigate]);
  return null;
};

const PageTitleManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let pageTitle = "Feed My Cycle";

    switch (pathname) {
      case "/":
        pageTitle = "Feed My Cycle";
        break;
      case "/privacy-policy":
        pageTitle = "Privacy Policy | Feed My Cycle";
        break;
      case "/terms-conditions":
        pageTitle = "Terms & Conditions | Feed My Cycle";
        break;
      case "/contact-us":
        pageTitle = "Contact Us | Feed My Cycle";
        break;
      default:
        pageTitle = "Page Not Found | Feed My Cycle";
        break;
    }

    document.title = `${pageTitle}`;
  }, [pathname]);

  return null;
};

const AppRoutes = () => (
  <>
    <ScrollToTop />
    <PageTitleManager />

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </>
);
export default AppRoutes;
